import React, { useContext, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import clsx from "clsx";
import MobileStepper from "@material-ui/core/MobileStepper";

import SurveyQuestionContext from "../../../context/surveyquestion-context";
import StudentContext from '../../../context/student-context';
import { postSurvey, getSurveySummary } from "../../../actions/survey-actions";
import { getStudentCoins } from '../../../actions/share-actions';
import { Buttons } from "../../shared/component";
import CompletedSurveyModal from "../modals/CompletedSurveyModal";
import SurveySummaryModal from "../modals/SurveySummaryModal";
import FlyingCoinAnimationModal from "../../shared/modals/FlyingCoinAnimationModal";
import Loading from "../../shared/Loading";
import ScaleQuestionHolder from "../questionTypes/ScaleQuestionHolder";
import MultipleChoiceQuestionHolder from "../questionTypes/MultipleChoiceQuestionHolder";
import CheckboxQuestionHolder from "../questionTypes/CheckboxQuestionHolder";
import OpenEndedQuestionHolder from "../questionTypes/OpenEndedQuestionHolder";

import { SnapShotSurveyData, SurveyData, Claims } from "../../../utils/services/cache/ClientCache";
import useStyles from "../../../styles/components/survey/stylesSurveyQuestionContainer";

const SurveyQuestionHolder = () => {
    const history = useHistory();
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const { surveyQuestionContext } = useContext(SurveyQuestionContext);
    const tutorialSteps = surveyQuestionContext.scaleContents.concat(
        surveyQuestionContext.multipleChoiceContents,
        surveyQuestionContext.rankingContents,
        surveyQuestionContext.checkboxContents,
        surveyQuestionContext.freeText)
    const [open, setOpen] = React.useState(false);
    const [notiOpen, setNotiOpen] = React.useState(false);
    const [gradeText, setGradeText] = React.useState('');
    const [recommendation, setRecommendation] = React.useState('');
    const [extraContent, setExtraContent] = React.useState({});
    const surveyId = Number(SurveyData.getSurveyGroupId());
    const [summaryOpen, setSummaryOpen] = React.useState(false);
    const [surveySummaryViewModel, setSurveySummaryViewModel] = React.useState([]);
    let answerSubmissionDataList = []
    const { studentContext, dispatchStudent } = useContext(StudentContext);

    const [snackBarDetails, setSnackBarDetails] = React.useState({
        open: false,
        message: '',
        type: '',
    });

    const handleSnackBarClose = () => setSnackBarDetails({ ...snackBarDetails, open: false });

    const inputSnackBarDetails = (message, type) => setSnackBarDetails({
        open: true,
        message,
        type
    });

    let surveyName = SnapShotSurveyData.getSnapshotSurveyName();

    const checkValidation = () => {
        let isError = false;
        let answerScaleEmpty = surveyQuestionContext.scaleAnswers.includes(undefined)
        let answerMultipleChoiceEmpty = surveyQuestionContext.multipleChoiceAnswers.includes(undefined)
        let answerrankingEmpty = surveyQuestionContext.rankingAnswers.includes(undefined)

        if (
            surveyQuestionContext.scaleContents.length > 0
            && (
                surveyQuestionContext.scaleAnswers.length < 1
                || surveyQuestionContext.scaleAnswers.length !== surveyQuestionContext.scaleContents.length
                || answerScaleEmpty
            )
        ) {
            inputSnackBarDetails("Scale Question Option Answers can't be empty", 'error');
            return isError = true;
        }
        if (
            surveyQuestionContext.multipleChoiceContents.length > 0
            && (
                surveyQuestionContext.multipleChoiceAnswers.length < 1
                || surveyQuestionContext.multipleChoiceAnswers.length !== surveyQuestionContext.multipleChoiceContents.length
                || answerMultipleChoiceEmpty
            )
        ) {
            inputSnackBarDetails("Multiple Choice Answers can't be empty", 'error');
            return isError = true;
        }
        if (
            surveyQuestionContext.rankingContents.length > 0
            && (
                surveyQuestionContext.rankingAnswers.length < 1
                || surveyQuestionContext.rankingAnswers.length !== surveyQuestionContext.rankingContents.length
                || answerrankingEmpty
            )
        ) {
            inputSnackBarDetails("Ranking Answers can't be empty", 'error');
            return isError = true;
        }
        if (surveyQuestionContext.checkboxContents.length > 0) {
            surveyQuestionContext.checkboxContents.map(item => {
                if (item.checkboxAnswerDictionary.length < 1) {
                    inputSnackBarDetails("CheckBox Answers can't be empty", 'error');
                    return isError = true;
                }
            })
        }

        return isError;
    }

    const submitSurvey = async () => {

        if (!checkValidation()) {

            setIsLoading(true);

            let id = Number(SnapShotSurveyData.getSnapshotSurveyId());

            let completedCount = SnapShotSurveyData.getSurveySectionCompletedCount();
            let totalCount = SnapShotSurveyData.getSurveySectionCount();
            let isLastSection = false;
            if (++completedCount == totalCount) // this mean it is last survey
            {
                isLastSection = true;
            }

            if (surveyQuestionContext.scaleAnswers.length > 0) {
                surveyQuestionContext.scaleAnswers.forEach((item) => {
                    let answerSubmissionData = {
                        QuestionId: item.questionId,
                        Point: item.point,
                        AnswerContent: item.scaleQuestionOptionContent,
                        StudentNumber: Claims.getGivenName(),
                        SurveyId: surveyId,
                        SectionId: id,
                        isLastSection: isLastSection,
                    }
                    answerSubmissionDataList.push(answerSubmissionData);
                })
            } //end of scale content answers

            if (surveyQuestionContext.multipleChoiceAnswers.length > 0) {
                surveyQuestionContext.multipleChoiceAnswers.forEach((item) => {
                    let answerSubmissionData = {
                        Point: 0,
                        QuestionId: item.questionId,
                        AnswerContent: item.questionOptionContent,
                        StudentNumber: Claims.getGivenName(),
                        SurveyId: surveyId,
                        SectionId: id,
                        isLastSection: isLastSection,
                    }
                    answerSubmissionDataList.push(answerSubmissionData);
                })
            } //end of multiple choice content answers

            if (surveyQuestionContext.checkboxContents.length > 0) {
                let answers = '', questionId = 0;
                surveyQuestionContext.checkboxContents.forEach((checkboxContent) => {
                    answers = '';
                    checkboxContent.checkboxAnswerDictionary.map((item, index) => {
                        questionId = item.questionId
                        if (checkboxContent.checkboxAnswerDictionary.length - 1 !== index) {
                            answers += item.questionOptionContent + ',';
                        }
                        else {
                            answers += item.questionOptionContent
                        }
                    });

                    let answerSubmissionData = {
                        Point: 0,
                        QuestionId: questionId,
                        AnswerContent: answers,
                        StudentNumber: Claims.getGivenName(),
                        SurveyId: surveyId,
                        SectionId: id,
                        isLastSection: isLastSection,
                    };
                    answerSubmissionDataList.push(answerSubmissionData);
                });

            } //end of checkbox content answers

            if (surveyQuestionContext.rankingAnswers.length > 0) {

                surveyQuestionContext.rankingAnswers.forEach((item) => {
                    let answerSubmissionData = {
                        Point: 0,
                        QuestionId: item.questionId,
                        AnswerContent: item.questionOptionContent,
                        StudentNumber: Claims.getGivenName(),
                        SurveyId: surveyId,
                        SectionId: id,
                        isLastSection: isLastSection,
                    }
                    answerSubmissionDataList.push(answerSubmissionData);
                })

            } //end of ranking content answers

            if (surveyQuestionContext.freeText.length > 0) {

                surveyQuestionContext.freeText.forEach((item) => {
                    let answerSubmissionData = {
                        Point: 0,
                        QuestionId: item.questionId,
                        AnswerContent: item.input,
                        StudentNumber: Claims.getGivenName(),
                        SurveyId: surveyId,
                        SectionId: id,
                        isLastSection: isLastSection,
                    }
                    answerSubmissionDataList.push(answerSubmissionData);
                })

            } //end of ranking content answers

            let response = await postSurvey(JSON.stringify(answerSubmissionDataList));
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            setIsLoading(false);
            setNotiOpen(true);
            if (response.data.categoryName.length > 0)
                setGradeText("Evaluation : " + response.data.categoryName);
            setRecommendation(response.data.description);
            setExtraContent(response.data);
        }
    }

    const notiCloseClick = async () => {
        const responseCoin = await getStudentCoins();
        if (responseCoin.status === "Success") {
            dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: responseCoin.data });
        }
        setNotiOpen(false);
        setOpen(true);
    }

    const handleClose = () => history.push("/Survey");

    const handleViewSummary = async () => {
        setOpen(false);
        let response = await getSurveySummary(surveyId);
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        if (response.status === "Success") {
            setSummaryOpen(true);
            setSurveySummaryViewModel(response.data)

            studentContext.dinosaur.level = 1;
            dispatchStudent({ type: 'SET_DINOSAUR', dinosaur: studentContext.dinosaur });
        }
    }

    const handleNext = () => {
        if (activeStep === tutorialSteps.length - 1) {
            submitSurvey()
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

    if (isLoading) return <Loading />;

    return (
        <>
            <Accordion expanded={true} classes={{ root: classes.rootAccordion }}>
                <AccordionSummary classes={{ content: classes.contentAccordionSummary }}>
                    <Grid container classes={{ root: classes.rootGrid }}>
                        {tutorialSteps.length > 0 &&
                            <>
                                {tutorialSteps[activeStep].type === 'Scale' && <ScaleQuestionHolder index={activeStep} />}
                                {tutorialSteps[activeStep].type === 'MultipleChoice' && <MultipleChoiceQuestionHolder tutorialSteps={tutorialSteps} index={activeStep} />}
                                {tutorialSteps[activeStep].type === 'Ranking' && <MultipleChoiceQuestionHolder tutorialSteps={tutorialSteps} index={activeStep} />}
                                {tutorialSteps[activeStep].type === 'Checkbox' && <CheckboxQuestionHolder index={activeStep} />}
                                {tutorialSteps[activeStep].type === 'FreeText' && <OpenEndedQuestionHolder index={activeStep} />}
                            </>
                        }
                    </Grid>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.rootMuiAccordionDetails }}>
                    <Grid container alignItems="center" classes={{ root: classes.rootGridButton }}>
                        <Buttons
                            text="Back"
                            onClick={handleBack}
                            disabled={activeStep === 0}
                            customClass='customButtonBack'
                        />
                        <Buttons text={activeStep === tutorialSteps.length - 1 ? "Submit" : "Next"} customClass='customButtonNext' onClick={handleNext} />
                    </Grid>
                    <Grid container alignItems="center" classes={{ root: classes.rootGridMobileStepper }}>
                        <MobileStepper
                            variant="progress"
                            steps={tutorialSteps.length + 1}
                            position="static"
                            activeStep={activeStep + 1}
                            classes={{
                                root: classes.rootMuiMobileStepper,
                                progress: classes.progressMuiMobileStepper,
                            }}
                        />
                        <Typography variant="body2" >{activeStep + 1} of {tutorialSteps.length}</Typography>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <CompletedSurveyModal isOpen={open} closeAction={handleClose} viewSummary={handleViewSummary} extraContent={extraContent}
                surveyName={surveyName} gradeText={gradeText} recommendation={recommendation} />
            <SurveySummaryModal isOpen={summaryOpen} closeAction={handleClose} surveySummaryViewModel={surveySummaryViewModel} />
            <Snackbar
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                key={`bottom, center`}
                open={snackBarDetails.open}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}>
                <Alert onClose={handleSnackBarClose} severity={snackBarDetails.type}>{snackBarDetails.message}</Alert>
            </Snackbar>
            <FlyingCoinAnimationModal _isOpen={notiOpen} _notiCloseClick={notiCloseClick} _extraContent={extraContent} />
        </>
    );
};

export default SurveyQuestionHolder;